var $9d2ed7be7fcdc2a1$exports = {};
$9d2ed7be7fcdc2a1$exports = {
  "breadcrumbs": "Chemin de navigation"
};
export { $9d2ed7be7fcdc2a1$exports as default };